import { render, staticRenderFns } from "./roastall.vue?vue&type=template&id=045e4938&"
import script from "./roastall.vue?vue&type=script&lang=js&"
export * from "./roastall.vue?vue&type=script&lang=js&"
import style0 from "./roastall.vue?vue&type=style&index=0&id=045e4938&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports